<template>
	<div class="b-price">
		<div class="b-price__item b-price__item_current">
			<span v-html="discountFormatted"></span>
		</div>
		<div class="b-price__item b-price__item_old" v-if="basePrice > 0 && basePrice > discountPrice">
			<span v-html="fullFormatted"></span>
		</div>
	</div>
</template>
<script>
	import {Vue} from "ui.vue";

	/**
	 * discountPrice - цена со скидкой
	 * basePrice - базовая цена без скидки
	 * currency - код валюты
	 * hasSku - есть торговые предложения
	 * showPriceFrom - выводить цену `От ...`
	 */
	export default {
		name: 'CitrusProductBasketPrice',
		props: {
			discountPrice: {
				type: [Number, String],
				required: false,
				default: 0
			},
			basePrice: {
				type: [Number, String],
				required: false,
				default: 0
			},
			currency: {
				type: String,
				required: false,
				default: 'RUB'
			},
			hasSku: {
				type: Boolean,
				required: false,
				default: false
			},
			showPriceFrom: {
				type: Boolean,
				required: false,
				default: true
			},
			emptyPriceText: {
				type: [Boolean, String],
				required: false,
				default: false
			},
		},

		computed: {

			loc() {
				return Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_BASKET_PRICE_");
			},

			discountFormatted() {
				return this.formatPrice(this.discountPrice, false);
			},

			fullFormatted() {
				return this.formatPrice(this.basePrice, false);
			},
		},

		methods: {

			/**
			 * Форматирование цены
			 * Для товаров с торговыми предложениями может выводится цена `От ...`
			 *
			 * @link https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
			 * @param price
			 * @param onlyNumber
			 * @returns {String}
			 */
			formatPrice: function (price, onlyNumber) {
				/** fix если у товара не задана цена, то выводим об этом надпись */
				if (price <= 0) {
					return this.emptyPriceText ? this.emptyPriceText : this.loc['CITRUS_VUE_PRODUCT_BASKET_PRICE_EMPTY'];
				}

				let formatedPrice = new Intl.NumberFormat("ru-RU", {
					style: (true === onlyNumber) ? "decimal" : "currency",
					currency: this.currency,
					minimumFractionDigits: 0,
					maximumFractionDigits: 2,
				}).format(Number(price));

				/**
				 * Выведем цену `Как есть`, если у товара нет торговых предложений и не указано условие вывода
				 */
				if (true !== this.hasSku || true !== this.showPriceFrom) {
					return formatedPrice;
				}

				if (
					true === this.hasSku
					&& this.loc.hasOwnProperty('CITRUS_VUE_PRODUCT_BASKET_PRICE_FROM')
				) {
					return this.loc['CITRUS_VUE_PRODUCT_BASKET_PRICE_FROM'].replace('#PRICE#', formatedPrice);
				}

				return formatedPrice;
			}
		}

	};
</script>